import type { InjectionKey, Ref, ComputedRef } from 'vue';
import type { NavState } from 'src/composables/use-nav-state';
import type { TreeNodes } from 'src/composables/use-tree-nodes';
import type { ViewAsUser } from 'src/composables/use-view-as-user';
import type { FormInfo, OrganizationInfo } from 'src/components/navigation/context-menu/use-view-settings-dialog-dependencies';
import type { ClientCultureInfo } from '@cognitoforms/types/server-types/client-culture-info';
import type { FieldInfo } from '@cognitoforms/types/server-types/model/field-info';
import type { Token } from 'src/components/form-controls/tokenUtils';
import type { LocalizationResources } from 'src/localization/resources/localization-resources.generated';
import type { OrganizationAuditLog } from 'src/composables/use-organization-audit-log';
import type { SiteManifest } from '@cognitoforms/utils/manifest-helpers';

export const navStateKey: InjectionKey<NavState> = Symbol('navState');
export const treeNodesKey: InjectionKey<TreeNodes> = Symbol('treeNodes');
export const isMobileKey: InjectionKey<Ref<boolean>> = Symbol('isMobile');
export const isDarkKey: InjectionKey<Ref<boolean>> = Symbol('isDark');
export const hasCustomThemeKey: InjectionKey<Ref<boolean>> = Symbol('hasCustomTheme');
export const fieldInfoDataKey: InjectionKey<ComputedRef<FieldInfo[]>> = Symbol('fieldInfoData');
export const cultureDataKey: InjectionKey<ComputedRef<ClientCultureInfo>> = Symbol('cultureData');
export const organizationInfoKey: InjectionKey<ComputedRef<OrganizationInfo>> = Symbol('organizationInfo');
export const formInfoKey: InjectionKey<ComputedRef<FormInfo>> = Symbol('formInfo');
export const tokensKey: InjectionKey<ComputedRef<Token[]>> = Symbol('tokens');
export const viewAsUserKey: InjectionKey<ViewAsUser> = Symbol('viewAsUser');
export const organizationAuditLogKey: InjectionKey<OrganizationAuditLog> = Symbol('organizationAuditLog');
export const localizationResourcesKey: InjectionKey<Ref<LocalizationResources>> = Symbol('localizationResources');
export const getSiteManifestKey: InjectionKey<() => Promise<SiteManifest>> = Symbol('siteManifest');
export const selectableCardGroupKey: InjectionKey<{ multiple: boolean; modelValue: Ref<unknown> }> = Symbol('selectableCardGroup');
